<template>
  <div class="body-div">
    <div class="main-chart">
      <canvas id="live-stats-sub-chart" width="1"></canvas>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../../helpers/api/request";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";
import { mapState } from "vuex";
//import DatePicker from "vue2-datepicker";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import UsersActiveScope from "../../clients_table.sub_feature.company/mixins/UsersActiveScope";
import UsersStatsActiveScope from "../../clients_table.sub_feature.company/mixins/UsersStatsActiveScope";

const mainChartOptions = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        /*     backgroundColor: function (context) {
                           return context.dataset.backgroundColor;
                         },*/
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        // display: function(context) {
        //   let index = context.dataIndex;
        //   let value = context.dataset.data[index];
        //   return value > 0; // display labels with a value greater than 0
        // },
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value, index) {
          value = value.toString();
          value = value.split(".").join("");
          value = parseInt(value);
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.7)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 6
          }
        }
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      enabled: true,
      mode: "single",
      callbacks: {
        label: (value, index, values) => {
          value = value.value.toString();
          value = value.split(".").join("");
          value = parseInt(value);

          return ["Count:" + value];
        }
      }
    }
  }
};
Chart.Tooltip.positioners.custom = function(elements, position) {
  if (!elements.length) {
    return false;
  }
  let offset = 0;
  //adjust the offset left or right depending on the event position
  if (elements[0]._chart.width / 2 > position.x) {
    offset = 20;
  } else {
    offset = -20;
  }
  return {
    x: position.x + offset,
    y: 0
  };
};
export default {
  name: "GeneralLiveStatsChart.component.component",
  components: {
    //DatePicker
  },
  mixins: [UsersActiveScope, UsersStatsActiveScope, UsersPermissionCheck],

  data() {
    return {
      mainChartOptions: {
        type: "bar",
        options: {
          layout: {
            padding: {
              top: 26
            }
          },
          plugins: {
            datalabels: {
              align: function(value) {
                if (value.datasetIndex === 0) {
                  return "end";
                }
                if (value.dataset.data[value.dataIndex] > 0) {
                  return "end";
                } else {
                  return "start";
                }
              },
              anchor: function(value) {
                if (value.datasetIndex === 0) {
                  return "end";
                }
                if (value.dataset.data[value.dataIndex] > 0) {
                  return "end";
                } else {
                  return "start";
                }
              },
              offset: -4,
              /*     backgroundColor: function (context) {
                               return context.dataset.backgroundColor;
                             },*/
              font: {
                family: "Arial",
                size: 11
              },

              // display: function(context) {
              //   let index = context.dataIndex;
              //   let value = context.dataset.data[index];
              //   return value > 0; // display labels with a value greater than 0
              // },
              color: function(context) {
                if (context.datasetIndex === 0) {
                  return context.dataset.borderColor;
                } else {
                  return "#000";
                }
              },
              formatter: (value, index) => {
                if (index.datasetIndex === 1) {
                  return value === 0 ? "" : this.avgRawStats[index.dataIndex];
                }
                if (index.datasetIndex === 2) {
                  return "";
                }
                value = value.toString();
                value = value.split(".").join("");
                value = parseInt(value);
                return value === 0 ? "" : value;
              }
            }
          },

          maintainAspectRatio: false,
          gradientColors: [
            "rgba(29,140,248,0.7)",
            "rgba(29,140,248,0.0)",
            "rgba(29,140,248,0)"
          ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  beginAtZero: true,
                  // display:false,
                  padding: 0,
                  fontColor: "transparent", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 8
                }
              }
            ],
            xAxes: [
              {
                minBarLength: 10,
                stacked: true,
                id: "bar-x-axis1",
                // barPercentage: 1.0,
                // categoryPercentage: 0.5,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0)"
                },
                ticks: {
                  padding: 0,
                  fontSize: 9
                }
              }
            ]
          },
          legend: {
            display: false
          },
          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          },
          tooltips: {
            position: "custom",
            enabled: true,
            mode: "single",
            fontSize: 6,
            callbacks: {
              label: (value, index, values) => {
                if (value.datasetIndex === 0) {
                  let vals = value.value.toString();
                  vals = vals.split(".").join("");
                  vals = parseInt(vals);

                  let data = ["Count:" + vals];
                  let label = value.label.toLowerCase();
                  if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
                    if (label === "na") {
                      if (this.expendedChartData[label]) {
                        data = this.formatExpendedDataForNa(data, label);
                      } else {
                        this.getExpendData(label);
                      }
                    }
                    if (label.includes("dp -")) {
                      let depLabel = "dep";
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForDep(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (label.includes("reg")) {
                      let depLabel = "reg";
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForReg(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (label.includes("ca")) {
                      let depLabel = "ca";
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForCa(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (label === "tr-lv" || label === "tr-on") {
                      let depLabel = label;
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForTr(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (
                      label === "bn" ||
                      label === "ni" ||
                      label === "ended" ||
                      label === "rf" ||
                      label === "ld"
                    ) {
                      let depLabel = label;
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForGroup(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                  }

                  return data;
                } else {
                  let msg;
                  let vals = value.value.toString();
                  vals = vals.split(".").join("");
                  vals = parseInt(vals);
                  if (vals > 0) {
                    msg = vals + " Below the AVG";
                  } else {
                    msg = vals + " Above the AVG";
                  }
                  return [msg];
                }
              }
            }
          }
        }
      },

      reqMainChartData: false,

      liveMode: false,
      loaderIcon: false,
      mainChartData: [],

      mainChartTabBuild: null,

      chartTimeOut: null,
      lastUpdate: null,

      statsDate: [moment().toDate(), moment().toDate()],
      usersList: [],
      selectedUser: null,
      tierOptions: [
        {
          id: 1,
          name: "ALL TIERS",
          alias: null
        },
        {
          id: 2,
          name: "TIER1",
          alias: "1"
        },
        {
          id: 3,
          name: "TIER2",
          alias: "2"
        },
        {
          id: 4,
          name: "TIER3",
          alias: "3"
        },
        {
          id: 5,
          name: "TIER4",
          alias: "4"
        }
      ],
      avgOptions: [
        {
          id: 1,
          name: "AVG 7",
          alias: 7
        },
        {
          id: 2,
          name: "AVG 30",
          alias: 30
        },
        {
          id: 3,
          name: "AVG 90",
          alias: 90
        },
        {
          id: 4,
          name: "AVG 180",
          alias: 180
        }
      ],
      selectedAvgRange: 30,
      selectedAvg: "AVG 30",
      selectedTierOption: null,
      expendedChartData: {},
      selectedTier: "ALL TIERS",
      LeadFiltersOptions: [
        {
          id: 1,
          name: "ALL LEADS",
          alias: "ALL"
        },
        {
          id: 2,
          name: "DUP",
          alias: "DUP"
        },
        {
          id: 3,
          name: "REG",
          alias: "REG"
        }
      ],
      selectedLeadFilter: "ALL",
      selectedLeadOption: "ALL LEADS",
      allAvgStats: {},
      avgRawStats: [],
      chartKeys: [
        ["COST", [1, 2]],
        ["REG", [1, 2, 3, 4, 5, 12]],
        ["NEW", [1, 2, 3, 4, 5, 12]],
        ["NR", [1, 2, 3, 4, 5, 12]],
        ["NI", [1, 2, 3, 4, 5, 12]],
        ["BN", [1, 2, 3, 4, 5, 12]],
        ["NU", [1, 2, 3, 4, 5, 12]],
        ["MERGED", [1, 2, 3, 4, 5, 12]],
        ["ENDED", [1, 2, 3, 4, 5, 12]],
        ["TR-LV", [1, 2, 3, 4, 5, 12]],
        ["TR-ON", [1, 2, 3, 4, 5, 12]],
        ["C2C", [1, 2, 3, 4, 5, 12]],
        ["SMS", [1, 2, 3, 4, 5, 12]],
        ["CA", [1, 2, 3, 4, 5, 12]],
        ["NA", [1, 2, 3, 4, 5, 12]],
        ["RF", [1, 2, 3, 4, 5, 12]],
        ["LD", [1, 2, 3, 4, 5, 12]],
        ["DEP", [1, 2, 3, 4, 5, 12]],
        ["CC-DEC", [1, 2, 3, 4, 5, 12]]
      ]
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "updateLiveChart",
      "salesPersonList",
      "subGraphData",
      "refreshGeneralLiveSmallStatsChart"
    ])
  },
  beforeDestroy() {
    this.$root.$off("updateLiveStats");
  },
  mounted() {
    this.usersList = this.FilterStatsNonActiveUsers(
      this.FilterNonActiveUsers()
    );
    // this.$root.$on("updateLiveStats", data => {
    //   this.statsDate = moment().toDate();
    //   // this.fetchMainChartData();
    // });
    // let canvasId = "live-stats-sub-chart";
    // let TempObject  = this.subGraphData;
    // this.mainChartData = TempObject.chartData;
    // this.allAvgStats = TempObject.avgData

    this.fetchMainChartData();
  },
  watch: {
    updateLiveChart: function() {
      if (this.updateLiveChart) {
        if (this.updateLiveChart.dates) {
          if (!this.updateLiveChart.dates.start) {
            this.updateLiveChart.dates.start = undefined;
          }
          if (!this.updateLiveChart.dates.end) {
            this.updateLiveChart.dates.end = undefined;
          }
          this.statsDate = [
            moment(this.updateLiveChart.dates.start).toDate(),
            moment(this.updateLiveChart.dates.end).toDate()
          ];
        } else {
          this.statsDate = [moment().toDate(), moment().toDate()];
        }
        if (this.updateLiveChart.lead_filter) {
          this.selectedLeadFilter = this.updateLiveChart.lead_filter;
          this.$store.commit(
            "clients/setLiveDataFilter",
            this.selectedLeadFilter
          );
        }
        // this.fetchMainChartData();
        this.$store.commit("clients/setUpdateLiveChart", false);
        // if(this.CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])){
        //   this.$store.commit('clients/setLiveChartDataToCalendar',{
        //     users:this.usersList,
        //     live_mode:true
        //   })
        // }
      }
    },
    // subGraphData:function(){
    //   let canvasId = "live-stats-sub-chart";
    //   let TempObject  = this.subGraphData;
    //   this.mainChartData = TempObject.chartData;
    //   this.allAvgStats = TempObject.avgData
    //
    //       this.createMainChart(
    //       this.mainChartData,
    //       canvasId,
    //       this.mainChartOptions,
    //       this.allAvgStats
    //   );
    // }


    refreshGeneralLiveSmallStatsChart(val){
      if(val) {
        this.fetchMainChartData();
      }
    }
  },
  methods: {
    clickOnDateButton() {
      this.$store.commit("clients/setLiveChartDataToCalendar", true);
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YY");
    },

    formatExpendedDataForNa(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(
            item.user + "[" + item.total + "] (" + item.percents + "%)"
          );
        });

        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }

      if (Object.keys(this.expendedChartData[label].camp).length > 0) {
        let camp = this.expendedChartData[label].camp;
        Object.keys(camp).map(item => {
          data.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
      }

      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempTier = [];
        Object.keys(tier).map(item => {
          tempTier.push(item + "-" + tier[item]);
        });
        data.push(tempTier);
      }
      return data;
    },
    formatExpendedDataForDep(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(item.user + "(" + item.count + ")");
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns[0];
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(item + " ");
          // tempArr.push(item + '(' + camp[item].count +')')
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }

      if (this.expendedChartData[label].brokers.length > 0) {
        let brokers = this.expendedChartData[label].brokers;
        let tempArr = [];
        brokers.map(item => {
          tempArr.push(item.broker.name + "(" + item.overall_count + ")");
          // tempArr.push(item + '(' + camp[item].count +')')
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].countries).length > 0) {
        let country = this.expendedChartData[label].countries[0];
        let tempArr = [];
        Object.keys(country).map(item => {
          tempArr.push(item + "(" + country[item].count + ")");
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers[0];
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(item + "(" + tier[item].count + ")");
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForReg(data, label) {
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForCa(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(
            item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (this.expendedChartData[label].reasons.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].reasons.map(item => {
          tempArr.push(
            item.status.type.substring(0, 15) +
              "[" +
              item.count +
              "](" +
              item.percents +
              "%)"
          );
        });
        let perChunk = 1; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForTr(data, label) {
      if (this.expendedChartData[label].users_to.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users_to.map(item => {
          tempArr.push(
            "TO " + item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (this.expendedChartData[label].users_by.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users_by.map(item => {
          tempArr.push(
            "BY " + item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForGroup(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(
            item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }

      return data;
    },

    chunksArray(tempArr, perChunk) {
      let arr = tempArr.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
      return arr;
    },
    selectLeadFilter(filter) {
      this.selectedLeadFilter = filter;
      this.$store.commit("clients/setLiveDataFilter", this.selectedLeadFilter);
      // this.fetchMainChartData();
    },
    selectTier(tier) {
      this.selectedTierOption = tier.alias;
      this.selectedTier = tier.name;
      // this.fetchMainChartData();
    },
    selectAvg(avg) {
      this.selectedAvgRange = avg.alias;
      this.selectedAvg = avg.name;
      // this.fetchMainChartData();
    },
    FilterNonActiveUsers() {
      return this.salesPersonList.filter(user => user.active !== 0);
    },

    async fetchMainChartData() {
      this.loaderIcon = true;
      if (this.$router.currentRoute.name === "Main") {
        if (this.chartTimeOut) {
          clearTimeout(this.chartTimeOut);
        }
        this.chartTimeOut = setInterval(() => {
          clearTimeout(this.chartTimeOut);
          this.chartTimeOut = null;
         /// this.fetchMainChartData();

          if (this.mainChartTabBuild) {
            this.mainChartTabBuild.destroy();
          }
        }, 120000);
        this.$emit("fetchStart");
        this.reqMainChartData = true;
        this.expendedChartData = {};
        let canvasId = "live-stats-sub-chart";
        this.mainChartData = [];
        // let queryObj = {
        //   stats_date_at: moment(this.statsDate[0]).format("YYYY-MM-DD"),
        //   stats_date_to: moment(this.statsDate[1]).format("YYYY-MM-DD")
        // };
        // if (this.selectedUser) {
        //   queryObj = { ...queryObj, user_id: this.selectedUser };
        // }
        // if (this.selectedTierOption) {
        //   queryObj = { ...queryObj, country_tiers: [this.selectedTierOption] };
        // }
        // switch (this.selectedLeadFilter) {
        //   case "ALL":
        //     delete queryObj.dup_exclude;
        //     delete queryObj.dup;
        //     break;
        //   case "DUP":
        //     delete queryObj.dup_exclude;
        //     queryObj.dup = 1;
        //     break;
        //   case "REG":
        //     queryObj.dup_exclude = 1;
        //     delete queryObj.dup;
        //     break;
        // }
        //
        // queryObj = { ...queryObj, avg_count: this.selectedAvgRange };
        // queryObj = { ...queryObj, special_req: 1 };
        if (this.mainChartTabBuild) {
          this.mainChartTabBuild.destroy();
        }
        if (
          Object.keys(this.allAvgStats).length === 0 &&
          this.CheckUserPermission([1, 2, 3, 4, 12])
        ) {
          await apiClientCreator(
            `reports/timely_report/average_report/overall/true`
          )
            .get("", {})
            .then(async res => {
              let tempObj = res.data;

              Object.keys(tempObj).map(days => {
                if (
                  Object.keys(tempObj[days]["bad_number_reasons"]).length === 0
                ) {
                  return;
                }
                this.allAvgStats[days] = {
                  REG: tempObj[days]["registrations"],
                  DUP: tempObj[days]["registrations"]
                };
              });
            })
            .catch(err => {});
        }
        await apiClientCreator(`client/stats/live_leads_stats`)
          .get("", {
            // params: queryObj
          })
          .then(async res => {
            this.lastUpdate = moment().format("DD/MM/YY HH:mm");
            this.$emit("setLastUpdate", this.lastUpdate);
            this.mainChartData = res.data;
            if (this.mainChartTabBuild) {
              this.mainChartTabBuild.destroy();
            }
            this.createMainChart(
              this.mainChartData,
              canvasId,
              this.mainChartOptions,
              this.allAvgStats
            );
            this.reqMainChartData = false;
            this.$store.commit("clients/setRefreshGeneralLiveSmallStatsChart", false);
          })
          .catch(err => {
            this.reqMainChartData = false;
            this.$store.commit("clients/setRefreshGeneralLiveSmallStatsChart", false);
          });
      }
      this.loaderIcon = false;
    },

    createMainChart(statsAll, canvasId, chartOpt, AvgStats) {
      let opt = chartOpt.options;
      let labels = [];
      let allStats = [];
      let allAvgStats = [];
      let statsAvg = Object.assign({}, AvgStats);
      let stats = Object.assign({}, statsAll);
      Object.keys(stats).forEach(data => {
        // if(data !== 'Cost' && data !== 'REG' && data !== 'NEW'){
        //   return;
        // }
        labels.push(data);
        if (`${stats[data]}`.length > 2) {
          let len = `${stats[data]}`.length;
          let val = stats[data];
          switch (len) {
            case 3:
              ///(parseInt(stats[data])<=500 && parseInt(stats[data])>=1 ) ? val = ((stats[data] / 10).toFixed(1)) : val = ((stats[data] / 10).toFixed(2));
              val = (stats[data] / 10).toFixed(1);
              break;
            case 4:
              val = (stats[data] / 100).toFixed(2);
              break;
            case 5:
              val = (stats[data] / 1000).toFixed(3);
              break;
          }
          allStats.push(val);
          return;
        }
        allStats.push(stats[data]);
      });
      // }

      try {
        if (
          Object.keys(statsAvg).length > 0 &&
          this.CheckUserPermission([1, 2, 3, 4, 12])
        ) {
          this.avgRawStats = [];
          Object.keys(stats).forEach(dataAvgKey => {
            let leadFilter = "REG";
            let dataAvgKeyOrig = dataAvgKey;
            let avgKey = dataAvgKey;
            if (avgKey === "DUP") {
              leadFilter = "DUP";
            }
            let valAvg;
            let showVal = 0;
            let lastPos = "total_in_time_frame";
            if (statsAvg[this.selectedAvgRange].hasOwnProperty(avgKey)) {
              if (!this.selectedTierOption) {
                if (!this.selectedUser) {
                  valAvg =
                    statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                      leadFilter
                    ][lastPos];
                } else {
                  if (avgKey === "REG" || avgKey === "NU") {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                        leadFilter
                      ][lastPos];
                  } else {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                        leadFilter
                      ].users[this.selectedUser].total;
                  }
                }
              } else {
                if (!this.selectedUser) {
                  valAvg =
                    statsAvg[this.selectedAvgRange][avgKey]["tiers"][
                      this.selectedTierOption
                    ][leadFilter][lastPos];
                } else {
                  if (avgKey === "REG" || avgKey === "NU") {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                        leadFilter
                      ][lastPos];
                  } else {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["tiers"][
                        this.selectedTierOption
                      ][leadFilter].users[this.selectedUser].total;
                  }
                }
              }

              if (valAvg === 0) {
                allAvgStats.push(valAvg - stats[dataAvgKeyOrig]);
                this.avgRawStats.push(valAvg);
                return;
              }
              showVal = valAvg;
              valAvg = valAvg - stats[dataAvgKeyOrig];
              if (valAvg) {
                if (`${valAvg}`.length > 2) {
                  let len = `${valAvg}`.length;

                  switch (len) {
                    case 3:
                      valAvg = (valAvg / 10).toFixed(1);
                      break;
                    case 4:
                      valAvg = (valAvg / 100).toFixed(2);
                      break;
                    case 5:
                      valAvg = (valAvg / 1000).toFixed(3);
                      break;
                  }
                  allAvgStats.push(valAvg);
                  this.avgRawStats.push(showVal);
                  return;
                }
              } else {
                valAvg = 0;
                showVal = 0;
              }

              allAvgStats.push(valAvg);
              this.avgRawStats.push(showVal);
            } else {
              allAvgStats.push(0);
              this.avgRawStats.push(0);
            }
          });
        }
      } catch (e) {}

      let pointers = [];
      this.avgRawStats.map(point => {
        if (`${point}`.length > 2) {
          let len = `${point}`.length;

          switch (len) {
            case 3:
              point = (point / 10).toFixed(1);
              break;
            case 4:
              point = (point / 100).toFixed(2);
              break;
            case 5:
              point = (point / 1000).toFixed(3);
              break;
          }
        }
        pointers.push(point);
      });

      let bgColors = [];
      let brdColors = [];

      let colors = {
        Cost: {
          bgColor: "rgb(255,0,0,0.7)",
          brdColor: "rgb(255,0,0,0.7)"
        },
        REG: {
          bgColor: "#1ac51a",
          brdColor: "#1ac51a"
        },
        DUP: {
          bgColor: "#1ac51a",
          brdColor: "#1ac51a"
        },
        NEW: {
          bgColor: "#1ac51a",
          brdColor: "#1ac51a"
        },
        ON: {
          bgColor: "#1ac51a",
          brdColor: "#1ac51a"
        }
      };
      labels.map(key => {
        bgColors.push(colors[key].bgColor);
        brdColors.push(colors[key].brdColor);
      });

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Count",
            data: allStats, //onlineTrans,
            fill: true,
            borderColor: brdColors,
            backgroundColor: bgColors,
            borderWidth: 0.5,
            maxBarThickness: 30,
            categoryPercentage: 1.0,
            barPercentage: 0.5
          },
          {
            type: "bar",
            label: "AVG",
            data: allAvgStats, //onlineTrans,
            fill: true,
            borderColor: brdColors,
            backgroundColor: "rgb(255,255,255)",
            borderWidth: 0.5,
            maxBarThickness: 30,
            categoryPercentage: 1.0,
            barPercentage: 0.5,
            minBarLength: function(value) {
              if (value.dataset.data[value.dataIndex] > 0) {
                return 15;
              } else {
                return 0;
              }
            }
          },
          {
            type: "line",
            label: "Live",
            fill: false,
            borderColor: "rgb(162,162,162)", //"rgba(186,231,85,0.9)",
            borderWith: 0.5,
            backgroundColor: "#e755ba",
            pointBackgroundColor: brdColors,
            pointBorderColor: "rgb(162,162,162)",
            pointHoverBackgroundColor: "rgb(162,162,162)",
            pointHoverBorderColor: "rgb(162,162,162)",
            data: pointers,
            hidden: true
          }
        ]
      };

      if (this.mainChartTabBuild) {
        this.mainChartTabBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.mainChartTabBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      ctx.onclick = evt => {
        this.clickLiveChart(this.mainChartTabBuild, evt, labels);
      };
    },

    clickLiveChart(myChart, evt, labelName) {
      const activePoints = myChart.getElementsAtEvent(evt);
      if (activePoints[0]) {
        const idx = activePoints[0]["_index"];
        let filter = labelName[idx];
        let preset = null;
        if (
          moment(this.statsDate[0]).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD") &&
          moment(this.statsDate[1]).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD")
        ) {
          preset = "TODAY";
        }
        if (
          moment(this.statsDate[0]).format("YYYY-MM-DD") ===
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD") &&
          moment(this.statsDate[1]).format("YYYY-MM-DD") ===
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD")
        ) {
          preset = "YESTERDAY";
        }

        this.$store.commit("clients/setGeneralChartFilter", {
          filter: filter,
          user: this.selectedUser,
          date: [
            moment(this.statsDate[0]).format("YYYY-MM-DD"),
            moment(this.statsDate[1]).format("YYYY-MM-DD")
          ],
          preset: preset,
          tier: this.selectedTierOption,
          lead_filter: this.selectedLeadFilter
        });
      }
    },
    notAfterToday(date) {
      return date > moment().toDate();
    },
    getClasses(date) {
      if (
        moment(this.statsDate).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
      ) {
        return "highlight";
      }
      return "";
    },
    async getExpendData(label) {
      this.loaderIcon = true;
      const filter = label;

      let queryObj = {
        stats_date_at: moment(this.statsDate[0]).format("YYYY-MM-DD"),
        stats_date_to: moment(this.statsDate[1]).format("YYYY-MM-DD")
      };
      if (this.selectedUser) {
        queryObj = { ...queryObj, user_id: this.selectedUser };
      }
      if (this.selectedTierOption) {
        queryObj = { ...queryObj, country_tiers: [this.selectedTierOption] };
      }
      queryObj = { ...queryObj, special_req: 1 };
      await apiClientCreator(`client/stats/today_chart/ext/${filter}`)
        .get("", { params: queryObj })
        .then(res => {
          this.expendedChartData[filter] = res.data;
          // this.loaderIcon = false;
        })
        .catch(err => {
          this.loaderIcon = false;
        });
      this.loaderIcon = false;
    }
  }
};
</script>

<style scoped>
/*@import "../../../../../../public/css/datePicker.css"; // TODO: Moved to CDN*/
html * {
  text-transform: capitalize;
}
.body-div {
  /*padding: 5px 5px 1px 5px;*/
  padding-top: 5px;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.main-chart {
  min-width: 100%;
  height: 100%;
  margin: auto;
  background: white;
  border-radius: 3px;
  /*padding: 5px;*/
  position: relative;
}
.last-update-date {
  position: absolute;
  font-size: 12px;
  z-index: 1;
  right: 1px;
  top: -5px;
}
.refresh-button {
  position: absolute;
  font-size: 10px;
  z-index: 1;
  right: 100px;
  top: -5px;
  height: 18px;
}
.report-calendar {
  /*margin-top: 13px;*/
}
.selection-user-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /*height: 30px;*/
  border-radius: 0px;
}
.dropdown-menu.ul-users {
  font-size: 14px;
  overflow-y: scroll;
  max-height: 167px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 200px;
}
.dropdown-menu.ul-tiers {
  font-size: 11px;
  max-height: 225px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 73px;
}
.dropdown-menu.ul-tiers > li > a {
  padding: 3px 12px;
}
.dropdown-menu {
  border-radius: 0;
}
.activedrop {
  background-color: #efefef;
}
/*.tiers-btns{*/
/*  flex: 1;*/
/*}*/
.tiers-btn {
  border: 0px;
  border-radius: 0px;
  width: 100%;
  font-size: 10px;
  height: 15px;
}
.tiers-btn p {
  margin-bottom: 0px;
}
.tiers-btn:focus {
  outline: none;
}
.tiers-btn.active {
  background-color: #44a2d2;
  color: #fff;
}
.selecting-options {
  display: flex;
}
.loader-icon {
  display: flex;
  justify-content: center;
}
.loader-icon > span > img {
  width: 15px;
}
</style>
